module.exports = __webpack_public_path__ + "img/01—01—Home Network Overview > WLAN Device PopOver.e23385f4.jpg";